<script>
import {map} from 'ramda'
export default {
	data() {
			return {
				position: {
					width:200,
					height:100,
					left: 48,
					bottom:36
				}
			}
		},

	computed: {
		boxPosition() {
			return map(unit => Number(unit)+'px', this.position)
		}
	}
}
</script>

<template>
    <div>
        <div class="sticker-container">
            <div class="sticker"></div>
            <div class="sticker-text-container" v-bind:style="boxPosition">
                <p>Texto</p>
            </div>
        </div>

        <div class="container">
            <div class="col s6">
                <label>Ancho:</label>
                <input type="number" v-model="position.width" />
            </div>

            <div class="col s6">
                <label>Alto:</label>
                <input type="number" v-model="position.height" />
            </div>

            <div class="col s6">
                <label>Posición desde el lado izquierdo:</label>
                <input type="number" v-model="position.left" />
            </div>

            <div class="col s6">
                <label>Posición desde la parte inferior:</label>
                <input type="number" v-model="position.bottom" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
	.sticker {
		border-radius: 100%;
		background-color: orange;
		width: 300px;
		height: 300px;
		border: 10px white solid;
		box-shadow: 0 0 3px #000;
		&-container {position: relative;}
	}
	.sticker-text-container {
		border: 3px dashed purple;
		border-radius: 5px;
		background-color: rgba(255,255,255,0.5);
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;

		p {
			color: yellow;
			font-size: 36px;
			text-align: center;
			padding-top: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// sticker-config.vue?0df9c94b